import { render } from "./BrandButton.vue?vue&type=template&id=d15ae826"
import script from "./BrandButton.vue?vue&type=script&lang=ts"
export * from "./BrandButton.vue?vue&type=script&lang=ts"
script.render = render

export default script